module.exports = __webpack_public_path__ + "static/media/futureproof.5a73ab4c.png";